'use strict';
var uncurryThis = require('../internals/function-uncurry-this');
var aCallable = require('../internals/a-callable');

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/function-uncurry-this-accessor.js
// module id = 1195
// module chunks = 0